import { saveAs } from "file-saver";

export async function handleResponse(response, returnError = false) {
  if (response.status === 401) {
    sessionStorage.removeItem("token");
    return undefined;
  }

  if (response.ok) {
    try {
      const jsonResponse = await response.json();
      return returnError
        ? { success: true, data: jsonResponse }
        : jsonResponse;
    } catch (error) {
      return returnError
        ? { success: true, data: null }
        : null;
    }
  }

  if (returnError) {
    try {
      const errorResponse = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorResponse.message || "Something went wrong",
      };
    } catch (error) {
      return {
        success: false,
        status: response.status,
        message: "An unknown error occurred.",
      };
    }
  } 

  return false;
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error("API call failed. " + error);
  // return error;
}

export function AddAuthorisationToHeader() {
  return {
    Authorization:
      "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
  };
}

export async function handleExceldownload(response) {
  if (response.status === 401) {
    sessionStorage.removeItem("token");
    return undefined;
  } else if (response.ok) {
    const filename = response.headers
      .get("content-disposition")
      .split(";")
      .find((n) => n.includes("filename="))
      .replace("filename=", "")
      .trim()
      .replace(/^"(.*)"$/, "$1");
    const blob = await response.blob();
    saveAs(blob, filename);
  } else {
    return false;
  }
}
